<template>
  <div>
    <div class="tx-small b-ta-center m0 scroll-msg">Scroll to learn about Blibli</div>
    <div class="mouse">
      <div class="mouse__scroller"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@blibli/blue-tokens/dist/blue-tokens.scss";
@import '@blibli/blue-dls-utils/dist/scss/responsive-mixins-helper';

@include desktop {
  .scroll-msg{ color:  $blu-black-medium;}
  .mouse {
    width: 3px;
    padding: 5px 10px;
    margin: auto;
    height: 25px;
    border: 2px solid $blu-black-medium;
    border-radius: 25px;
    opacity: 0.75;
    box-sizing: content-box;
    &__scroller {
      width: 2px;
      height: 8px;
      border-radius: 25%;
      background-color: $blu-black-medium;
      animation-name: scroll;
      animation-duration: 1s;
      animation-timing-function: cubic-bezier(0.15, 0.41, 0.69, 0.94);
      animation-iteration-count: infinite;
    }
  }
}
@keyframes scroll {
  100% {
    transform: translateY(8px);
  }
}
</style>
